<template>
  <div id="settings">
    <div class="btn-settings text" @click="changeLanguage('en')">
      <div
        class="square"
        :class="{ full: currentLang === 'en', light: !darkMode }"
      />
      EN
    </div>
    <div class="btn-settings text" @click="changeLanguage('fr')">
      <div
        class="square"
        :class="{ full: currentLang === 'fr', light: !darkMode }"
      />
      FR
    </div>
    <div class="btn-settings text" @click="toggleDarkMode(true)">
      <div class="square" :class="{ full: darkMode, light: !darkMode }" />
      {{ $t("settings.dark") }}
    </div>
    <div class="btn-settings text" @click="toggleDarkMode(false)">
      <div class="square" :class="{ full: !darkMode, light: !darkMode }" />
      {{ $t("settings.light") }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import store from "@/store";

export default defineComponent({
  name: "settings",
  methods: {
    toggleDarkMode(mode: boolean) {
      if (mode !== this.darkMode) {
        store.commit("toggleDarkMode");
      }
    },
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
    },
  },
  computed: {
    darkMode() {
      return store.state.darkMode;
    },
    currentLang() {
      return this.$i18n.locale;
    },
  },
});
</script>

<style scoped>
#settings {
  position: absolute;
  left: -15px;
  bottom: -5px;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  display: flex;
  text-transform: uppercase;
}

.btn-settings {
  display: flex;
  width: 11px;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
}
.square {
  height: 8px;
  width: 8px;
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid #ececec;
}

.square.light {
  border-color: #212121;
}

.square.full {
  background-color: #ececec;
}

.square.full.light {
  background-color: #212121;
}

@media (min-width: 768px) {
  #settings {
    left: -21px;
  }

  .square {
    height: 10px;
    width: 10px;
  }

  .btn-settings {
    width: 12px;
  }
}
</style>
